<template>
  <v-dialog v-model="show" width="700" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Edit</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" class="pb-0 mb-0">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="lc.messageCode"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" class="pb-0 mb-0">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="lc.message"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" class="pb-0 mb-0">
            <v-text-field
              label="Certified By"
              :class="classPadding"
              v-model="lc.certifiedBy"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" class="pb-0 mb-0">
            <v-text-field
              label="Position"
              :class="classPadding"
              v-model="lc.certifiedPos"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="error" @click.stop="show = false">Close</v-btn>
        <v-btn
          text
          color="success"
          @click.stop="save"
          :loading="isSaving"
          v-if="userAccess.update >= 1"
          >Update</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import userAccessMixin from "../../../../mixins/userAccessMixin";
import { encyrptText } from "../../../../helpers/user";
const API_ENDPOINT = "/api/letterContent";
export default {
  metaInfo: {
    title: "Edit Letter Content",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`,
  },
  mixins: [userAccessMixin],
  data: () => ({
    classPadding: "my-0 py-0",
    show: true,
    lc: {},
    isSaving: false,
  }),
  methods: {
    save() {
      this.isSaving = true;
      var newModel = {
        messageCode: this.lc.messageCode,
        message: this.lc.message,
        certifiedBy: encyrptText(this.lc.certifiedBy),
        certifiedPos: encyrptText(this.lc.certifiedPos),
      };
      this.$axios
        .put(`${API_ENDPOINT}`, newModel)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.$router.push("/letter-content");
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    getByCode(code) {
      this.$axios
        .get(`${API_ENDPOINT}/${code}`)
        .then(({ data }) => {
          this.lc = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
  },
  created() {
    let code = this.$route.params.code;
    this.getByCode(code);

    this.getUserAccessRights("Message");
  },
  watch: {
    show(val) {
      if (!val) {
        this.$router.push("/letter-content");
      }
    },
  },
};
</script>
